import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

import { staffQueryOptions } from "../../../../features/staff/queries"

const StaffSearchSchema = z.object({
  search: z.coerce.string().optional().catch(""),
  page: z.coerce.number().catch(1),
  pageSize: z.coerce.number().catch(10),
  facilities: z.array(z.coerce.number()).optional().catch(undefined),
  role: z.coerce.number().optional().catch(undefined),
})

export const Route = createFileRoute("/_app/manage/users/")({
  validateSearch: (search: SearchSchemaInput) =>
    StaffSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    return context.queryClient.ensureQueryData(
      staffQueryOptions({ params: { query: deps } })
    )
  },
})
